import React, { useContext } from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/context';
import { MEASUREMENT_TYPE } from 'pages/dimensions/const';
import { MeasurementBannerContainer, MeasurmentBannerTextWrapper, MeasurmentBannersWrapper } from './styles';

export const MeasurementBanner = () => {
  const data = useContext(DataContext);
  const services = data?.surfaces?.services?.[0];
  const isShowMeasurementBanner = data?.surfaces.services?.length && services?.type === MEASUREMENT_TYPE;
  const priceMin = typeof services?.priceMin === 'number' ? services.priceMin : 0;

  const handleClickCallMaster = () => {
    window.open(services?.serviceURL, '_blank', 'noopener noreferrer');
  };

  // расскоментить когда появится стабильная инструкция
  // const handleClickOpenInstruction = () => {
  //   window.open(services?.serviceURL, '_blank', 'noopener noreferrer');
  // };

  return (
    <>
      {isShowMeasurementBanner ? (
        <MeasurmentBannersWrapper>
          <MeasurementBannerContainer>
            <MeasurmentBannerTextWrapper>
              <Typography size="overline" variant="s">
                Профессиональный замер
              </Typography>
              <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
                {services?.name}
              </Typography>
            </MeasurmentBannerTextWrapper>

            <RegularButton
              data-testid="call-master-button"
              invert
              rounded
              size="s"
              variant="primary"
              onClick={handleClickCallMaster}>
              Вызвать мастера от {priceMin} ₽
            </RegularButton>
          </MeasurementBannerContainer>

          {/* расскоментировать, когда появится стабильная инструкция */}
          {/* <SelfMeasurementBannerContainer notAlone={!!isShowMeasurementBanner}>
        <MeasurmentBannerTextWrapper>
          <Typography size="overline" variant="s">
            Самостоятельный замер
          </Typography>
          <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
            Простая инструкция поможет измерить комнату для&nbsp;расчета
          </Typography>
        </MeasurmentBannerTextWrapper>

        <RegularButton
          data-testid="call-master-button"
          invert
          rounded
          size="m"
          variant="primary"
          onClick={handleClickOpenInstruction}>
          Открыть инструкцию
        </RegularButton>
      </SelfMeasurementBannerContainer> */}
        </MeasurmentBannersWrapper>
      ) : null}
    </>
  );
};
